const LOCALE_FALLBACKS: { [key: string]: string } = {
  en: 'en-US',
  fr: 'fr-FR',
}
const AVAILABLE_LOCALES = Object.values(LOCALE_FALLBACKS)
const DEFAULT_LOCALE = AVAILABLE_LOCALES[0]
const LOCALE_QUERY_PARAM_NAME = 'locale'

const getMatchingLocale = (locale: string): string => {
  if (AVAILABLE_LOCALES.includes(locale)) {
    return locale
  }
  const langOnly = locale.split('-')[0]
  return LOCALE_FALLBACKS[langOnly]
}

export const getLocale = (): string => {
  // parse locale from URL
  const localeFromUrl = new URL(window.location.href).searchParams.get(LOCALE_QUERY_PARAM_NAME)
  if (localeFromUrl) {
    const locale = getMatchingLocale(localeFromUrl)
    if (locale) return locale
  }

  // parse locale from configured preferred languages
  let locale
  window.navigator.languages.some((language) => {
    return (locale = getMatchingLocale(language))
  })

  return locale ?? DEFAULT_LOCALE
}
